module.exports = __webpack_public_path__ + "static/media/dog.bc5979a0.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/dog.jpg
 ** module id = 413
 ** module chunks = 0
 **/